import React from "react";
import { Alerta, Botao, TipoAlerta, CampoTexto } from "@intechprev/componentes-web";
import { Session } from "@intech/react-service";

import packageJson from "../../../package.json";

import { PageClean } from "../";

import { UsuarioService } from "../../services";
import { Link } from "react-router-dom";
import { LoginEntidade } from "../../entidades";

import reCAPTCHA from "../../helpers/reCAPTCHA";
import ReCAPTCHA from "react-google-recaptcha";

import config from "./../../config.json";
import moment from "moment";

export { EsqueciSenha } from "./EsqueciSenha";
export { Termos } from "./Termos";
export { TrocarSenhaPrimeiroAcesso } from "./TrocarSenhaPrimeiroAcesso";

interface Props {
  history?: any;
}

interface State {
  cpf: string;
  senha: string;
  mensagem: string;
  erro: string;
  tipoInputSenha: string;
  iconeBotaoSenha: string;
  tituloBotaoSenha: string;
  tokenDigitado: string;
  tokenEnviado: string;
  usaDoisFatoresViaSMS: boolean;
  ReCAPTCHATokenV2: string;
  mostrarReCAPTCHA: boolean;
  expiraEm: number;
  timer: string;
}

export class Login extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("login");

  private timer: NodeJS.Timeout;

  state = {
    cpf: "",
    senha: "",
    mensagem: "",
    erro: "",
    tipoInputSenha: "password",
    iconeBotaoSenha: "fas fa-eye",
    tituloBotaoSenha: "Mostrar Senha",
    tokenDigitado: "",
    tokenEnviado: "",
    usaDoisFatoresViaSMS: false,
    ReCAPTCHATokenV2: "",
    mostrarReCAPTCHA: false,
    expiraEm: 0,
    timer: ""
  };

  onSubmit = async () => {
    await this.setState({ erro: "" });

    try {
      const user = new LoginEntidade();
      user.Cpf = this.state.cpf;
      user.Senha = this.state.senha;
      user.TokenDigitado = this.state.tokenDigitado;
      user.TokenEnviado = this.state.tokenEnviado;
      user.ReCAPTCHATokenV2 = this.state.ReCAPTCHATokenV2;
      user.ReCAPTCHATokenV3 = await this.recaptcha.getToken();
      user.Origem = 1;
      user.ExpiraEm = this.state.expiraEm;

      const login = await UsuarioService.Login(user);

      if (login.AccessToken) {
        await Session.setToken(login.AccessToken);

        if (login.Redireciona === true) {
          await this.props.history.push(login.URL);
          return;
        }

        const matriculas = await UsuarioService.BuscarMatriculas();

        clearInterval(this.timer);
        
        // Se tiver só uma matricula, "auto seleciona" ela
        if (matriculas.length > 1) {
          await this.props.history.push("selecionarMatricula");
        } else {
          await this.props.history.push("/");
        }
      } else {
        const tokenEnviado = login.TokenDoisFatores;
        const usaDoisFatoresViaSMS = login.UsaDoisFatoresViaSMS;

        this.startTimer();

        this.setState({
          tokenEnviado,
          usaDoisFatoresViaSMS,
          mostrarReCAPTCHA: false,
          ReCAPTCHATokenV2: "",
          expiraEm: login.ExpiraEm,
        });
      }
    } catch (erro) {
      // const mostrarReCAPTCHA = false;
      const mostrarReCAPTCHA = erro.message.indexOf("401") > -1;
      this.setState({
        erro: erro.response ? erro.response.data : erro,
        mostrarReCAPTCHA,
        ReCAPTCHATokenV2: ""
      });
    }
  };

  alternarSenhaVisivel = () => {
    const senhaVisivel = this.state.tipoInputSenha === "password";
    this.setState({
      tipoInputSenha: senhaVisivel ? "text" : "password",
      iconeBotaoSenha: senhaVisivel ? "fas fa-eye-slash" : "fas fa-eye",
      tituloBotaoSenha: senhaVisivel ? "Esconder Senha" : "Mostrar Senha",
    });
  };

  startTimer = () => {
    this.timer = setInterval(() => {
      const date1 = moment(new Date(this.state.expiraEm / 1e+4 + new Date('0001-01-01T03:00:00Z').getTime()));
      const now = moment();
      const duration = moment.duration(date1.diff(now));
      this.setState({ timer: duration.minutes() + ":" + ((duration.seconds()).toFixed(0)) });

      if (this.state.tokenEnviado && duration.minutes() <= 0 && duration.seconds() <= 0) {
        alert("Código de confirmação expirado. Por favor, tente novamente.");
        clearInterval(this.timer);
        this.setState({ tokenEnviado: "" });
      }
    }, 1000);
  }

  render() {
    return (
      <PageClean {...this.props}>
        <h4>Bem vindo ao portal da PREVIRB</h4>

        <h5>
          <b>Área de Acesso Restrito</b>
          <br />
          <small>
            Para informações, entre em contato com a{" "}
            <a target="_blank" href="https://www.previrb.com.br/fale-conosco/" rel="noopener noreferrer">
              PREVIRB
            </a>
          </small>
          <br />
          <br />
        </h5>

        {this.state.tokenEnviado === "" && (
          <form>
            <CampoTexto contexto={this} nome={"cpf"} valor={this.state.cpf} placeholder={"CPF (somente números)"} />

            <CampoTexto
              contexto={this}
              nome={"senha"}
              valor={this.state.senha}
              placeholder={"Senha"}
              tipo={this.state.tipoInputSenha}
              grupo
              tituloBotao={this.state.tituloBotaoSenha}
              iconeBotao={this.state.iconeBotaoSenha}
              iconeBotaoDireita
              onBotaoClick={this.alternarSenhaVisivel}
            />

            {this.state.mensagem !== "" && <Alerta tipo={TipoAlerta.info} mensagem={this.state.mensagem} />}
            {this.state.erro !== "" && <Alerta tipo={TipoAlerta.danger} mensagem={this.state.erro} />}

            <Botao usaLoading titulo={"Entrar"} block onClick={this.onSubmit} submit />

            <div className={"form-group"}>
              <Link className={"btn btn-link"} id={"esqueciSenha"} to={"/esqueciSenha"}>
                Esqueci Minha Senha / Primeiro Acesso
              </Link>
            </div>
          </form>
        )}

        {this.state.tokenEnviado !== "" && (
          <form>
            {this.state.usaDoisFatoresViaSMS &&
              <Alerta
                tipo={TipoAlerta.success}
                mensagem={
                  "Para maior segurança, enviamos um código de confirmação para o celular cadastrado. Favor digitar o código no campo abaixo para poder acessar o Portal."
                }
              />
            }

            {!this.state.usaDoisFatoresViaSMS && <Alerta tipo={TipoAlerta.danger} mensagem={"Para maior segurança, estamos temporariamente enviando um código de confirmação para o email cadastrado. Favor, digitar o código no campo abaixo para poder acessar o Portal."} />}

            <Alerta tipo={TipoAlerta.info} mensagem={`O código de confirmação expira em ${this.state.timer} minutos.`} />

            <CampoTexto contexto={this} nome={"tokenDigitado"} valor={this.state.tokenDigitado} placeholder={"Código de Confirmação"} />

            <Alerta tipo={TipoAlerta.danger} mensagem={this.state.erro} />

            <Botao usaLoading titulo={"Entrar"} block onClick={this.onSubmit} submit />
          </form>
        )}

        {this.state.mostrarReCAPTCHA &&
          <ReCAPTCHA
            sitekey={config.reCAPTCHA_site_key_v2}
            onChange={(value: any) => this.setState({ ReCAPTCHATokenV2: value })}
          />
        }

        <br />
        <br />
        <div className="text-center">Versão {packageJson.version}</div>
      </PageClean>
    );
  }
}
